export default "__VITE_ASSET__CBbl4IRY__"